var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "GraphicsOutput",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <circle cx="38.14" cy="32" r="5.14"/>
    <path d="M20,21.86a4,4,0,0,0-4,4V38.14a4,4,0,0,0,4,4H44a4,4,0,0,0,4-4V25.86a4,4,0,0,0-4-4Zm7.66,14.21a2.88,2.88,0,0,1-.44,0H19.36a.63.63,0,0,1-.6-.69.64.64,0,0,1,.6-.7,2.69,2.69,0,0,1,.35,0h7.56a1.63,1.63,0,0,1,.43,0,.64.64,0,0,1,.49.71A.62.62,0,0,1,27.66,36.08Zm0-2.49a2.88,2.88,0,0,1-.44,0H19.36a.63.63,0,0,1-.6-.69.64.64,0,0,1,.6-.7,2.68,2.68,0,0,1,.35,0h7.56a1.63,1.63,0,0,1,.43,0,.64.64,0,0,1,.49.71A.62.62,0,0,1,27.66,33.58Zm0-2.49a2.88,2.88,0,0,1-.44,0H19.36a.63.63,0,0,1-.6-.69.64.64,0,0,1,.6-.7,2.69,2.69,0,0,1,.35,0h7.56a1.63,1.63,0,0,1,.43,0,.64.64,0,0,1,.49.71A.62.62,0,0,1,27.66,31.09Zm0-2.49a2.88,2.88,0,0,1-.44,0H19.36a.63.63,0,0,1-.6-.69.64.64,0,0,1,.6-.7,2.68,2.68,0,0,1,.35,0h7.56a1.63,1.63,0,0,1,.43,0,.64.64,0,0,1,.49.71A.62.62,0,0,1,27.66,28.6ZM38.14,39.14A7.14,7.14,0,1,1,45.28,32,7.15,7.15,0,0,1,38.14,39.14Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/graphics_output.svg